import { Column, Text, StatProps, StatColumn } from "@bridgesplit/ui";
import { Divider } from "@mui/material";
import { COPY } from "app/constants";

export default function OracleTooltipTitle({
    topLevelOracleStats,
    customOracleStats
}: {
    topLevelOracleStats: StatProps[] | undefined;
    customOracleStats: StatProps[] | undefined;
}) {
    return (
        <Column spacing={1.5} padding={1}>
            <Text variant="h4">{COPY.ORACLE_TERM_PLURAL}</Text>
            <StatColumn stats={topLevelOracleStats} />
            {customOracleStats && customOracleStats.length > 0 && (
                <>
                    <Divider />
                    <StatColumn stats={customOracleStats} />
                </>
            )}
        </Column>
    );
}
